module.exports = require("./uz-Cyrl-UZ.js");